<template>
  <div>
    <div class="contador_numero font-weight-bold" v-if="valor>0">
      <animated-number :value="valor" :formatValue="formatoConteo" :duration="duracion" />
    </div>
    <div class="contador_descripcion font-weight-medium" v-text="descripcion"></div>
  </div>
</template>
<script>
import AnimatedNumber from "animated-number-vue";
export default {
  components: {
    AnimatedNumber
  },
  props: {
    valor:{
      type: Number,
      default:0
    },
    descripcion: {
      type: String,
      default:""
    },
    duracion:{
        type:Number,
        default:3000
    }
  },
  methods: {
    formatoConteo(value) {
      return `${value.toFixed(0)}`;
    }
  }
};
</script>
<style scoped>
.contador_numero {
    font-size: 1.5rem;
    font-weight: 400;
    margin-bottom: 5px;
}
.contador_descripcion {
    font-size: 1rem;
    font-weight: 400 !important;
    font-style: italic;
    color: gray;
}
</style>


// WEBPACK FOOTER //
// src/components/Inicio/Contador.vue